import React from 'react';
import { Link } from 'react-router-dom';
import { Header, Nav, Logo, NavLinks, LanguageToggle, LangButton } from './SharedStyles';

function Navbar({ links = [], showLanguageToggle = false, currentLang, onLanguageChange }) {
  return (
    <Header>
      <Nav>
        <Logo id="navbar-logo-001">Buyer<span>PersonaX</span></Logo>
        <NavLinks>
          {links.map((link, index) => (
            link.to ? (
              <Link key={index} to={link.to} id={link.id}>
                {link.icon} {link.label}
              </Link>
            ) : (
              <a key={index} href={link.href} id={link.id}>
                {link.icon} {link.label}
              </a>
            )
          ))}
          {showLanguageToggle && onLanguageChange && (
            <LanguageToggle>
              <LangButton
                id="navbar-lang-en-002"
                active={currentLang === 'en'}
                onClick={() => onLanguageChange('en')}
              >
                EN
              </LangButton>
              <LangButton
                id="navbar-lang-es-003"
                active={currentLang === 'es'}
                onClick={() => onLanguageChange('es')}
              >
                ES
              </LangButton>
            </LanguageToggle>
          )}
        </NavLinks>
      </Nav>
    </Header>
  );
}

export default Navbar;
